import React from 'react';
import AButton from '../../../common/form-fields-mui/AButton';
import { useGetExamChargesContext } from '../context';
import { formattedPrice } from '../../collectPayment/utils';

const _= require('lodash');

const summaryFieldMappings = [
    { label: 'Total Fees', keyName: 'totalBaseAmount' },
    { label: 'Concession applied', keyName: 'totalConcessionAmount' },
    { label: "Payable amount", keyName: 'totalPayableAmount' },
    { label: 'Taxes', keyName: 'totalTaxes' },
    { label: 'Net Payable Amount', keyName: 'totalFinalPayable' },
]

const DetailsRow = ({ label, value }) => {
    return (
        <div className='details-row'>
            <span className='detail-cell-label'>{label} : </span>
            <span className='detail-cell-value'>{formattedPrice(value)}</span>
        </div>
    )
}

const ChargesSummary = () => {

    const { setOnPaymentCollectionStep , setBalanceAmount, amountToBePaid, selectedCharges, ...context } = useGetExamChargesContext();
    const summaryData = _.pick(context , [
        "totalBaseAmount",
        "totalConcessionAmount",
        "totalPayableAmount",
        "totalTaxes",
        "totalFinalPayable"
      ])

      const collectNowClickHandler = () => {
        setOnPaymentCollectionStep(true); 
        setBalanceAmount(amountToBePaid);
      }

    return (
        <div className='exam-charges-summary-card'>
            <h2>Finalize Charges</h2>
            <div>
                {summaryFieldMappings?.map(({ label, keyName }) =>
                    <DetailsRow key={label} label={label} value={summaryData[keyName]} />
                )}

            </div>

            <AButton
                variant='primary_filled'
                className='no-ml-btn mt-2'
                onClick={collectNowClickHandler}
                disabled={selectedCharges['OTHER_CHARGES']?.length === 0}
            >
                Collect now
            </AButton>


        </div>
    );
}

export default ChargesSummary;